// --- NO modificar Generado automáticamente ----
export default {
// --- Usa varaible .env URL_PORTAL_BACKEND  ----
  serverURI: 'http://admin-demoportal.artfosdev.com/index.php/',
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js